import NiceModal from "@ebay/nice-modal-react";

import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import ModalBase from "modals/base/ModalBase";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./Modal.module.css";
import P from "components/P";
import Inline from "layouts/container/Inline";
import paymentCompleteImg from "resources/dummy/Group 102.png";
import completeImg from "resources/img/puffu/gif/complete.gif";
import { useNavigate } from "react-router-dom";
import CustomButton from "components/buttons/CustomButton";
import ProcessBar from "routes/front/main/vending/mainPage/ProcessBar";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { useDispatch } from "react-redux";

const PaymentCompleteModal = NiceModal.create(props => {
  const { t } = useTranslation();
  const [withHeader, withFooter] = [false, false];
  const [width, height] = ["60%", "50%"];
  const withCloseButton = false;
  const modal = useRef();
  const clickOutsideToClose = false;
  const title = t("");
  const buttonText = t("close");
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const size = 100; // SVG 크기
  const strokeWidth = 10; // 테두리 두께
  const circleSize = size - strokeWidth * 2; // 원의 실제 크기
  const radius = (size - strokeWidth) / 2; // 반지름 계산
  const circumference = radius * 2 * Math.PI; // 원의 둘레
  const strokeDashoffset = ((countdown - 5) / 5) * circumference;
  useEffect(() => {
    // 타이머가 0이 아닐 경우에만 setTimeout을 설정합니다.
    if (countdown >= 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1); // 1초마다 카운트다운을 감소시킵니다.
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      dispatch(CartReducer.actions.reset());
      modal.current.close();
      // navigate(`/ws/5/home`); // 카운트다운이 0이 되면 홈페이지로 이동합니다.
    }
  }, [countdown]);

  const onHomeBtnClick = () => {
    
    modal.current.close();
    navigate(`/ws/5/home`);
  }

  return (
    <ModalBase
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
      overflow={"visible"}
      borderRadius={"30px"}
    >
      <div style={{ padding: "20px" }}>
        <VerticalFlex gap={20}>
          <FlexChild alignItems={"flex-start"}>
            <div style={{ position: 'relative', width: size, height: size }}>
              <svg
                width={size}
                height={size}
                viewBox={`0 0 ${size} ${size}`}
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  stroke="#EC4715"
                  strokeWidth={strokeWidth}
                  fill="none"
                  cx={size / 2}
                  cy={size / 2}
                  r={radius}
                  strokeDasharray={circumference}
                  strokeDashoffset={strokeDashoffset}
                  transform={`rotate(-90 ${size / 2} ${size / 2})`}
                  style={{ transition: 'stroke-dashoffset 1s linear' }} // 애니메이션 효과
                />
              </svg>
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '50px',
                  width: circleSize,
                  height: circleSize,
                  borderRadius: '50%',
                  backgroundColor: '#EC4715',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {countdown}
              </div>
            </div>
          </FlexChild>
          <FlexChild height={"max-content"}>
            <ProcessBar modal complete />
            <div style={{ width: "100%", height: "2px", backgroundColor: "black" }} />
          </FlexChild>
          <FlexChild>
            <P size={30} weight={"bold"} color={"black"}>
              결제가 완료되었습니다.
            </P>
          </FlexChild>
          <FlexChild>
            <P color={"#757575"} size={20}>
              구매해주셔서 감사합니다.
            </P>
          </FlexChild>
          <FlexChild>
            <div
              style={{
                width: "80%",
                height: "1px",
                backgroundColor: "#757575",
              }}
            />
          </FlexChild>
          <FlexChild>
            <Inline>
              <P size={32} color={"#FE531F"} weight={"bold"}>
                자판기
              </P>
              <P color={"black"} size={32} weight={"bold"}>
                에서 물건을 가져가세요!
              </P>
            </Inline>
          </FlexChild>
          <FlexChild>
            <img src={completeImg} height={"70%"} width={"70%"} />
          </FlexChild>
          <FlexChild>
            <CustomButton onClick={onHomeBtnClick} text={"처음으로"} />
          </FlexChild>
        </VerticalFlex>
      </div>
    </ModalBase>
  );
});

export default PaymentCompleteModal;
